/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Payment_ReferenceInputs */

const vi_payment_reference = /** @type {(inputs: Payment_ReferenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tham chiếu`)
};

/**

* @param {Payment_ReferenceInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const payment_reference = /** @type {((inputs?: Payment_ReferenceInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Payment_ReferenceInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_payment_reference(inputs)
});